var map = {
	"./applicationModules/admin-module/admin-module.module": [
		"./src/app/applicationModules/admin-module/admin-module.module.ts",
		"default~applicationModules-admin-module-admin-module-module~applicationModules-loginModule-login-mod~9108cb60",
		"common",
		"applicationModules-admin-module-admin-module-module"
	],
	"./applicationModules/loginModule/login-module.module": [
		"./src/app/applicationModules/loginModule/login-module.module.ts",
		"default~applicationModules-admin-module-admin-module-module~applicationModules-loginModule-login-mod~9108cb60",
		"common",
		"applicationModules-loginModule-login-module-module"
	],
	"./applicationModules/registerModule/register.module": [
		"./src/app/applicationModules/registerModule/register.module.ts",
		"default~applicationModules-admin-module-admin-module-module~applicationModules-loginModule-login-mod~9108cb60",
		"common",
		"applicationModules-registerModule-register-module"
	],
	"./modules/master/master.module": [
		"./src/app/applicationModules/admin-module/modules/master/master.module.ts",
		"default~applicationModules-admin-module-admin-module-module~applicationModules-loginModule-login-mod~9108cb60",
		"common",
		"modules-master-master-module"
	],
	"./modules/material/material.module": [
		"./src/app/applicationModules/admin-module/modules/material/material.module.ts",
		"default~applicationModules-admin-module-admin-module-module~applicationModules-loginModule-login-mod~9108cb60",
		"default~modules-material-material-module~modules-permissions-permissions-module~modules-work-work-mo~c301e6d5",
		"default~modules-material-material-module~modules-work-work-module",
		"common",
		"modules-material-material-module"
	],
	"./modules/permissions/permissions.module": [
		"./src/app/applicationModules/admin-module/modules/permissions/permissions.module.ts",
		"default~applicationModules-admin-module-admin-module-module~applicationModules-loginModule-login-mod~9108cb60",
		"default~modules-material-material-module~modules-permissions-permissions-module~modules-work-work-mo~c301e6d5",
		"common",
		"modules-permissions-permissions-module"
	],
	"./modules/work/work.module": [
		"./src/app/applicationModules/admin-module/modules/work/work.module.ts",
		"default~applicationModules-admin-module-admin-module-module~applicationModules-loginModule-login-mod~9108cb60",
		"default~modules-material-material-module~modules-permissions-permissions-module~modules-work-work-mo~c301e6d5",
		"default~modules-material-material-module~modules-work-work-module",
		"common",
		"modules-work-work-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;